const info = (context, message) => {
    if (context && message) {
        context.$message.info(message)
    }
}

const success = (context, message) => {
    if (context && message) {
        context.$message.success(message)
    }
}

const warning = (context, message) => {
    if (context && message) {
        context.$message.warning(message)
    }
}

const error = (context, message) => {
    if (context && message) {
        context.$message.error(message)
    }
}

const custom = (context, message, type) => {
    if (context && message) {
        context.$message({message: message, type: type ? type : "info"});
    }
}


///吐司统一封装
export default {
    info,
    success,
    warning,
    error,
    custom
}